/**
 * Non-sensitive storage keys only. Access and refresh tokens are NEVER persisted here — they
 * live in memory only (docs/development/FrontendGuidelines.md §4.4/§6.4). Everything in here is a UI
 * *preference*: losing it, or having it read by anyone with the device, costs the user nothing.
 */
export const STORAGE_KEYS = {
  themeMode: 'willnq.themeMode',
  /** Whether the desktop side nav is collapsed to its icon rail. */
  navCollapsed: 'willnq.nav.collapsed',
} as const;
